import pasteModalInDom from "./helpers/pasteModalInDom";
import initPersonalDataButtonsForOpen from "./helpers/initPersonalDataButtonsForOpen";
import initPhoneMaskForModal from "./helpers/phoneMask";

export const setTariffFormButtonData = () => {

    let tariffForm = document.querySelector('#tariff-modal form');
    const tariffButtons = document.querySelectorAll('.tariff-button');

    tariffButtons.forEach(tariffButton => {
        tariffButton.addEventListener('click', async () => {

            if (!tariffForm) {
                const ok = await pasteModalInDom("tariff-modal");
                if (!ok) return;
                tariffForm = document.querySelector('#tariff-modal form');
                initPersonalDataButtonsForOpen();
                initPhoneMaskForModal(tariffForm);
            }

            const iconElement = tariffForm.querySelector('.popap-accordion_title .icon img');
            if (iconElement) {
                iconElement.src = tariffButton.dataset.icon;
                iconElement.alt = tariffButton.dataset.name;
            }

            const nameElement = tariffForm.querySelector('.popap-accordion_title .name span');
            if (nameElement) {
                nameElement.textContent = tariffButton.dataset.name;
            }

            const priceElement = tariffForm.querySelector('.field_price');
            if (priceElement) {
                priceElement.textContent = tariffButton.dataset.price;
            }

            const connectionFeeElement = tariffForm.querySelector('.field_connection_fee');
            if (connectionFeeElement) {
                connectionFeeElement.textContent = tariffButton.dataset.connectionfee ? tariffButton.dataset.connectionfee : '0';
            }

            tariffForm.querySelector("input[name=type]").value = tariffButton.dataset.type;
            tariffForm.querySelector("input[name=provider_name]").value = tariffButton.dataset.provider_name;

            //open popup
            const tariffModal = document.getElementById('tariff-modal');
            const formSuccess = tariffModal.querySelector('.form-data__result');
            const form = tariffModal.querySelector('.form-data__input');
            const message = form.querySelector('.message')
            if (!tariffModal.classList.contains('active')) {
                message.innerHTML = '';
                tariffModal.classList.add('active');
                tariffModal.classList.remove('hide');
                tariffButton.classList.add('active');
                form.classList.remove('hide');
                formSuccess.classList.add('hide');
            }
            initTariffModalCloseButton(tariffModal);
        });

        function initTariffModalCloseButton(tariffModal) {
            const closeButtons = document.querySelectorAll(
                '#tariff-modal .modal-close-circle, #tariff-modal .free-consult__sent-button'
            );

            closeButtons.forEach((btn) => {
                if (btn.dataset.isInit === "1") return;
                btn.dataset.isInit = "1";

                btn.addEventListener("click", () => {
                    if (!tariffModal?.classList.contains("active")) return;
                    tariffModal.classList.remove("active");
                    tariffModal.classList.add("hide");
                });
            });
        }

    });
}
export default setTariffFormButtonData;
